import { useState, useEffect } from 'react';

const useFilteredDoctors = (bridgeTable: any[], providers: any[], appointmentTypeId: number | null | number[]) => {
  const [filteredData, setFilteredData] = useState<{ doctorList: any[], doctorIds: number[] }>({
    doctorList: [],
    doctorIds: [],
  });

  useEffect(() => {
    if (appointmentTypeId !== null) {
      const doctorIds = bridgeTable
        .filter(entry => entry.appointment_type_id === appointmentTypeId)
        .map(entry => entry.doctor_id);

      const uniqueDoctorIds = Array.from(new Set(doctorIds));
      const doctorList = uniqueDoctorIds.map(id => providers.find(provider => provider.id === id)).filter(Boolean);

      setFilteredData({
        doctorList,
        doctorIds: uniqueDoctorIds,
      });
    } else {
      setFilteredData({
        doctorList: [],
        doctorIds: [],
      });
    }
  }, [bridgeTable, providers, appointmentTypeId]);

  return filteredData;
};

export default useFilteredDoctors;
